const addressFragment = `
  address1
  address2
  city
  country
  firstName
  lastName
  id
  phone
  province
  zip`

export const customerAccessTokenCreateMutation = `
  mutation customerAccessTokenCreate($input: CustomerAccessTokenCreateInput!) {
    customerAccessTokenCreate(input: $input) {
        customerAccessToken {
          accessToken
          expiresAt
        }
        customerUserErrors {
          code
          field
          message
        }
    }
  }`

export const customerQuery = (accessToken) => `
  query {
    customer(customerAccessToken: "${accessToken}") {
      id
      firstName
      lastName
      acceptsMarketing
      email
      phone
      defaultAddress {
        ${addressFragment}
      }
      lastIncompleteCheckout {
        id
      }
    }
  }`

export const customerAddressCreateMutation = `
  mutation customerAddressCreate($address: MailingAddressInput!, $customerAccessToken: String!) {
    customerAddressCreate(address: $address, customerAccessToken: $customerAccessToken) {
      customerAddress {
        ${addressFragment}
      }
      customerUserErrors {
        code
        field
        message
      }
    }
  }`

export const customerCreateMutation = `
  mutation customerCreate($input: CustomerCreateInput!) {
    customerCreate(input: $input) {
      customer {
        id
        email
        firstName
        lastName
      }
      customerUserErrors {
        code
        field
        message
      }
    }
  }`

export const customerRecoverMutation = `
  mutation customerRecover($email: String!) {
  customerRecover(email: $email) {
    customerUserErrors {
      code
      field
      message
    }
  }
}`

export const customerResetByUrlMutation = `
  mutation customerResetByUrl($password: String!, $resetUrl: URL!) {
    customerResetByUrl(password: $password, resetUrl: $resetUrl) {
      customer {
        id
        email
        firstName
        lastName
      }        
      customerAccessToken {
        accessToken
        expiresAt
      }
      customerUserErrors {
        code
        field
        message
      }
    }
  }`

export const customerActivateByUrlMutation = `
  mutation customerActivateByUrl($password: String!, $activationUrl: URL!) {
    customerActivateByUrl(password: $password, activationUrl: $activationUrl) {
      customer {
        id
        email
        firstName
        lastName
      }        
      customerAccessToken {
        accessToken
        expiresAt
      }
      customerUserErrors {
        code
        field
        message
      }
    }
  }`
